// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"999":"aa7ed8b47a9a70ba","2888":"8adb675862428dc5"}[chunkId] + ".css";
};